export interface SecondLevelOptionInterface {
    value?: string;
    label?: string;
    disabled?: boolean;
    disabledLabel?: string;
    isFake?: boolean;
}

export class SecondLevelOptionModel implements SecondLevelOptionInterface {
    public value?: string;
    public label?: string;
    public disabled?: boolean;
    public disabledLabel?: string;
    public isFake?: boolean;
    constructor( value?: string, label?: string, disabled?: boolean, disabledLabel?: string, isFake?: boolean ) {
        this.value = ( value ) ? value : 'nfdlkgjbdfgjlhbvdfajlhbgvdfjgbhl';
        this.label = ( label ) ? label :  '';
        this.disabled = ( disabled ) ? disabled :  false;
        this.disabledLabel = ( disabledLabel ) ? disabledLabel :  '';
        this.isFake =  ( isFake ) ? isFake : false;
    }
}
